export const motherTongue = [
  { code: 'TE', label: 'Telugu' },
  { code: 'EN', label: 'English' },
  { code: 'BE', label: 'Bengali' },
  { code: 'KA', label: 'Kannada' },
  { code: 'TA', label: 'Tamil' },  
];

export const ethnicity = [
  { code: 'TE', label: 'Treditional' },
  { code: 'EN', label: 'Intimate Scenes' },
  { code: 'BE', label: 'Kiss Scene' },
  { code: 'KA', label: 'Kannada' },
  { code: 'TA', label: 'Tamil' },  
];

export const actingSkills = [
  { code: 'TE', label: 'Stage Shows' },
  { code: 'EN', label: 'Anchoring' },
  { code: 'BE', label: 'Modeling' },
  { code: 'KA', label: 'Road Shows' },
  { code: 'TA', label: 'Radio' },  
];
export const singingSkills = [
  { code: 'TE', label: 'Carnatic Vocalist' },
  { code: 'EN', label: 'Western' },
  { code: 'BE', label: 'Sufi /Folk' },
  { code: 'KA', label: 'Hindustani Vocalist' },
  { code: 'TA', label: 'Tamil' },  
];

export const primaryIndustryRegion = [
  { code: 'HB', label: 'Hindi/Bollywood' },
  { code: 'EN', label: 'English/Hollywood' },
  { code: 'TE', label: 'Telugu/Tollywood' },
  { code: 'TA', label: 'Tamil/Koliwood' },  
  { code: 'BE', label: 'Bengali' },
  { code: 'KA', label: 'Kannada' },
];

export const SKILLS = [
  'Assamese',
  'Kannada',
  'Punjabi',
  'Oriya',
  'Bangali',
  'Malayalam',
  'Sindhi',
  'English',
  'Bhojpuri',
  'Marathi',
  'Tamil',
  'Gujarati',
  'Others'    
];

export const PROFILEEXPERIENCED = [
  'Commercials',
  'Music Videos',
  'Radio',
  'Corporate Films',
  'Anchoring',
  'Stage Shows',
  'TV Commercials',   
  'Road Shows',   
  'News Presenting',
  'Event Launches',
  'Film',
  'Telivision',
  'Theatre',    
  'Modeling',
  'TV  / Serials'    
];
export const IND_LOCATION=[
  'Assamese',
  'Kannada',
  'Punjabi',
  'Oriya',
  'Bangali',
  'Malayalam',
  'Sindhi',
  'English',
  'Bhojpuri',
  'Marathi',
  'Tamil',
  'Gujarati',
  'Others'
];
export const MEA_INDUSTRIES = [
  { code: 'FO', label: 'FILM & OTT' },
  { code: 'TV', label: 'TV' },
  { code: 'DR', label: 'DRAMA' },
  { code: 'DFA', label: 'THEATRE & PERFORMING ARTS' },
  { code: 'FM', label: 'FASHION & MODELLING' },
  { code: 'DA', label: 'DANCE' },
  { code: 'VS', label: 'VOICE & SINGING' },
  { code: 'MB', label: 'MUSIC & BANDS' },

];


export const INTERESTED_IN = [
  'Film',
  'Telivision',
  'Theatre',    
  'Modeling',
  'TV  / Serials',
  'Commercials',
  'Music Videos',
  'Radio',
  'Corporate Films',
  'Anchoring',
  'Stage Shows',
  'TV Commercials',   
  'Road Shows',   
  'News Presenting',
  'Event Launches',
];
